import { useRecoilValue } from 'recoil';
import { dialogState } from 'state';
import { Dialog } from '@mui/material';

import { DialogTypes } from 'types/types';

import { AddProjectDialog } from 'components/GlobalDialog/AddProjectDialog';
import { AddUserDialog } from 'components/GlobalDialog/AddUserDialog';
import { AddSubProjectDialog } from 'components/GlobalDialog/AddSubProjectDialog';
import { AddPatientDialog } from 'components/GlobalDialog/AddPatientDialog';
import { AddVisitDialog } from './AddVisitDialog';
import { AddVisitTemplateDialog } from './AddVisitTemplateDialog';
import { AddFormTemplateTypeDialog } from './AddFormTemplateType';
import { AddFieldTemplateDialog } from './AddFieldTemplate/AddFieldTemplateDialog';
import { FormValidationErrorsDialog } from './FormValidationErrorsDialog';
import { EditLayoutItemDialog } from './EditLayoutItem/EditLayoutItemDialog';
import FormConfirmationDialog from './FormConfirmationDialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { EditHeaderDialog } from './EditHeaderDialog';
import EditSelectableTableFieldDialog from './EditSelectableTableFieldDialog';
import CommentDialog from './CommentDialog/CommentDialog';
import { AddReportTemplateDialog } from './AddReportTemplate';

function getDialog(dialogType: DialogTypes) {
  switch (dialogType) {
    case DialogTypes.addProject:
      return <AddProjectDialog />;
    case DialogTypes.addUser:
      return <AddUserDialog />;
    case DialogTypes.addGroup:
      return <AddSubProjectDialog />;
    case DialogTypes.addPatient:
      return <AddPatientDialog />;
    case DialogTypes.addVisit:
      return <AddVisitDialog />;
    case DialogTypes.addVisitTemplate:
      return <AddVisitTemplateDialog />;
    case DialogTypes.addFormTemplateType:
      return <AddFormTemplateTypeDialog />;
    case DialogTypes.addFieldDialog:
      return <AddFieldTemplateDialog />;
    case DialogTypes.formValidationErrors:
      return <FormValidationErrorsDialog />;
    case DialogTypes.editLayoutItem:
      return <EditLayoutItemDialog />;
    case DialogTypes.editHeaderItem:
      return <EditHeaderDialog />;
    case DialogTypes.formConfirmation:
      return <FormConfirmationDialog />;
    case DialogTypes.editSelectableTableField:
      return <EditSelectableTableFieldDialog />;
    case DialogTypes.comment:
      return <CommentDialog />;
    case DialogTypes.reportTemplate:
      return <AddReportTemplateDialog />;

    default:
      return null;
  }
}

export function GlobalDialog() {
  const { isOpen, dialogType, sx } = useRecoilValue(dialogState);
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));
  const isFieldDialog = dialogType === DialogTypes.addFieldDialog;

  return (
    <Dialog
      scroll={'paper'}
      open={isOpen ?? false}
      sx={{
        ...sx,
        pt: isMobile ? 0 : 12,
      }}
      fullWidth
      maxWidth={isFieldDialog ? 'xl' : 'md'}
      fullScreen={isMobile}
    >
      {dialogType && getDialog(dialogType)}
    </Dialog>
  );
}
